<template>
  <div class="meniu_produse">
    <section class="container_sectiune_meniu" >
      <div class="containerg sectiune1">  </div>
      <div class="containerg meniu_produse2"> 
        <div class="categorii_flex">
          <div class="slic_vue_overflox_x slic_meniu" v-if="categorii.length">
             <div  v-for="categorie in categorii_cu_produse" :key="categorie.id"  :data-scroll="'prod'+categorie.slug" class="box_categorie nume_categorie_swiper">
              <a v-if="categorie.products.length > 0"  @click="mergiLaCategorie(categorie.slug)" >{{categorie.name}}</a>
             </div>
          </div>
          <!-- <div class="slic_vue_overflox_x slic_meniu">
            <swiper ref="mySwiper" :options="swiperOptions">
              <swiper-slide v-for="categorie in categorii_cu_produse" :key="categorie.id"  :data-scroll="'prod'+categorie.slug" class="box_categorie nume_categorie_swiper">
                <div v-if="categorie.products.length > 0" @click="mergiLaCategorie(categorie.slug)">{{categorie.name}}</div>
              </swiper-slide>
            </swiper> 
                
          </div> -->
          <div class="prev-next">
            <div @click="showPrevCategorii" class="prev_class prev_next_class" slot="button-prev"><i class="ri-arrow-left-s-line "></i></div>
            <div @click="showNextCategorii" class="next_class prev_next_class" slot="button-next"><i class="ri-arrow-right-s-line"></i></div>
          </div>
        </div>

      </div>
    </section>

    <section class="sectiune_mobile containerg meniu_produse_search">
      <form action="/search">
       <div class="search_relative ">
        <input class="search_header_mobile" type="search" name='keywords' placeholder="Search food.."/>
         <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'search' }" class="icon_search"/>
       </div>
       </form>
    </section>
    <section class="container_sectiune_categorii_produse meniu_produse containerg">
      <div v-for="categorie in categorii_cu_produse" :key="categorie.id" :data-anchor="'prod'+categorie.slug" :class="'padding_text_container produse-'+categorie.slug" >
        <div>
          <div class="text_container" v-if="$i18n.locale == 'ro' && categorie.products.length > 0">
            {{categorie.name}} 
          </div>
          <div class="text_container" v-else-if="$i18n.locale == 'en' && categorie.products.length > 0">
            {{categorie.name}}
          </div>
          <div class="produse" v-if="categorie.products.length > 0">
              <div :dataslug="produs.additional.slug_ro" v-for="produs in categorie.products" :key="produs.id" class="box_produs box_general box_gen_mob" @click="deschidereModalProdus(produs.additional.slug_ro, $event)" >
                <div class="positionrelative box_top">
                  <div v-if="$store.state.status_bucatarie == '2' && produs.preparing_time == 'Normal'" class="produs_indisponibil">
                    Indisponibil momentan
                  </div>
                  <div v-if="produs.main_image.length > 0">
                    <div v-for="imagine in produs.main_image.slice(0,1)" :key="imagine.thumbnailpath">
                      <img :src="imagine.thumbnailpath"/>
                    </div>
                  </div>
                  <div v-else>
                    <img src='@/assets/images/poza_default1.jpg' />
                  </div>
                  <i  v-if="filter(produs.id)" class="ri-heart-fill heart_absolute favorit element_desktop" :datastatus="0" :dataid="produs.id"></i>
                  <i v-else class="ri-heart-line heart_absolute nefavorit element_desktop" :datastatus="1" :dataid="produs.id"></i>
                  <div class="reducere_icon" v-if="produs.discount > 0">
                      -{{produs.discount}}%
                  </div>
                </div>
                  <div class="box_bottom">
                    <div class="titlu_box" v-if="$i18n.locale == 'ro'">
                      {{ produs.additional.name_ro }}
                    </div>
                    <div class="titlu_box" v-else>
                      {{ produs.additional.name_en }}
                    </div>
                    <div class="reducere_icon" v-if="produs.discount > 0">
                        -{{produs.discount}}%
                    </div>
                    <div class="descriere_box" v-if="$i18n.locale == 'ro'">
                      {{produs.additional.description_ro | strippedContent}}
                    </div>
                    <div class="descriere_box" v-else>
                      {{produs.additional.description_en | strippedContent}}
                    </div>
                  </div>
                  <div class="pret_cumpara">
                    
                    <div class="box_pret_container" v-if="produs.discount > 0">
                      <div class="pret_box_taiat" >{{ produs.price }} lei</div>
                      <div class="pret_box" >{{ produs.price_final }} lei</div>
                      
                    </div>
                    <div class="box_pret_container" v-else>
                      <div class="pret_box" >{{ produs.price }} lei</div>
                    </div>
                    <div class="plus_produs" ><i class="ri-add-line"></i></div>
                  </div>   
              </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  //import VueSlickCarousel from 'vue-slick-carousel'
  //import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
  import $ from 'jquery'
  import axios from 'axios';
  import Vue from 'vue';
  import Vuex from 'vuex';
  Vue.use(Vuex)


  

  import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'

  export default {
    metaInfo() {
        return {
            title: 'Meniu Tiki Bistro | Livrări și take-away | În fiecare zi',
            meta: [
                { name: 'description', content: 'Mâncăruri delicioase, exotice, selectate cu grijă din intreaga lume precum: Sushi, starters, soups, main dishes, salads.'},
                { property: 'og:title', content: 'Meniu Tiki Bistro | Livrări și take-away | În fiecare zi'},
                { property: 'og:site_name', content: 'Tiki Bistro'},
                { property: 'og:description', content: 'Mâncăruri delicioase, exotice, selectate cu grijă din intreaga lume precum: Sushi, starters, soups, main dishes, salads.'},
                {property: 'og:type', content: 'website'},    
                {name: 'robots', content: 'index,follow'}   
            ]
        }
    },
    name: 'MyComponent',
    components: {  
      //Swiper,
      //SwiperSlide       
    },
    directives: {
      swiper: directive
    },
    methods: {
      showNextCategorii() {
        //this.$refs.carouselCategorii.next() 
         $('.slic_vue_overflox_x').animate( { scrollLeft: '+=400' }, 300);
      },
      showPrevCategorii() {
        //this.$refs.carouselCategorii.prev() 
        $('.slic_vue_overflox_x').animate( { scrollLeft: '-=400' }, 300);
      },
      showModal_produs(){
        this.$root.$refs.Header.showModal_header_produs();
      },   
      deschidereModalProdus(slug,event) {
        this.produse_extra = []
        this.$root.$refs.Header.afisare_modal_produs(slug,event);
      },
      
      mergiLaCategorie(slug) {
        $("html, body").animate({ scrollTop: $('.produse-'+slug).offset().top - 150 }, 300);
      },
      filter(id_produs){
        return this.$root.$refs.Header.filter(id_produs);
      },
    },
    data() {
      return {
        // swiperOptions: {
        //   spaceBetween: 30,
        //   slidesPerGroup: 1,
        //   loop: false,
        //   speed: 0,
        //   watchActiveIndex: true,
        //   slidesPerView: 6,
        //   slidesPerGroupSkip : 1,
        //   loopFillGroupWithBlank: true,
        //   navigation: {
        //     nextEl: '.next_class',
        //     prevEl: '.prev_class'
        //   },
        //    breakpoints: {       
        //       320: {       
        //         slidesPerView: 3,
        //         spaceBetween: 10     
        //       },          
        //       992: {       
        //         slidesPerView: 3,       
        //         spaceBetween: 50     
        //       },     
        //       1024: {       
        //         slidesPerView: 5,       
        //         spaceBetween: 30     
        //       } 
        //   } 
        // },
        categorii : [], 
        categorii_cu_produse : [],
        nume_produs : "",
        descriere_produs : "",
        imagine_produs : "",
        external_id: "",
        pret : "",
        alergeni_ro:"",
        alergeni_en:"",
        ingrediente_extra : [],
        produse_favorite : [],
        id_produs : '', 
        count: 1,
        produse_extra: [],
        show : false,
        url_delivery : 0
      }
    },
    computed: {
      // swiper() {
      //   return this.$refs.mySwiper.$swiper
      // }
    },
    beforeMount() {
      if(window.location.hostname == 'test.tikibistro.ro' || window.location.hostname == '192.168.1.80' )
        this.url_delivery = 1;
      
      this.produse_favorite_state = this.$store.state.products_id;
      axios.get('https://xpanel.tikibistro.ro/api/categories?t='+Number(new Date()),{ 
          withCredentials: false,
          params: { location: this.$store.state.location_shop }
        })
        .then(response => {
            this.categorii = response.data.data;
            var array_categorii = [];
            response.data.data.forEach(category => { 
              if(((category.products.length > 0 && category.slug != 'test' && this.url_delivery == 0) || (category.products.length > 0 && this.url_delivery == 1)) && category.fullmenu == 1)
                  array_categorii.push(category);
            })
            this.categorii_cu_produse = array_categorii;
        })
    }, 
   
    mounted () { 
      //this.swiper.slideTo(0, 1000, false)
      var that = this;

        $(window).scroll(function() {
            var windscroll = $(window).scrollTop();
            if (windscroll >= 450) {
                $('.padding_text_container').each(function(i) {
                 
                    if ($(this).position().top <= windscroll - 20) {
                        
                        if(!$('.box_categorie').eq(i).hasClass('cat_act'))
                        {
                          $('.box_categorie.cat_act').removeClass('cat_act');
                          $('.box_categorie').eq(i).addClass('cat_act'); 
                        
                         // $('.cat_act').scrollIntoView();
                         // $('cat_act').offset() + $('cat_act').outerWidth(true)/2
                         //that.swiper.slideTo(getSlideIndexByClass('cat_act'),0);


                         var element = $('.cat_act')[0];
                          element.scrollIntoView({behavior: "smooth" ,inline: "center"});
                          
                          
                        }
                       
                                     
                    }
                });
            } else {
                
                if(!$('.box_categorie:first').hasClass('cat_act'))
                {
                  $('.box_categorie.cat_act').removeClass('cat_act');
                  $('.box_categorie:first').addClass('cat_act');
                }
                  
            }
        }).scroll();

      function getSlideIndexByClass(className) {
        var index = 0;
        $.each($('.slic_meniu .swiper-wrapper').children(), function(i, item) {
          if ($(item).hasClass(className)) {
            index = i;
            return false;
          }
        });
        return index;
      }

      $('.search_header_mobile').focus( function() {
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          $('.sectiune_fixa_mobil').hide();
        }
      });

      $('.search_header_mobile').blur( function() {
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          $('.sectiune_fixa_mobil').fadeIn(100);
        }
      });
      $('.search_header_mobile').keypress(function(event){
          var keycode = (event.keyCode ? event.keyCode : event.which);
          if(keycode == '13'){
              var search_key = $('.search_header_mobile').val();
              window.location.href = '/search?keywords='+search_key;
          }
          event.stopPropagation();
      });
     }, 
    filters: {
        strippedContent: function(string) {
              return string.replace(/<\/?[^>]+>/ig, ""); 
        }
    }
  }
</script>